export default __webpack_public_path__ + "static/media/webLoginBg.23ff4d76.jpg";